import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'slick-carousel';
import 'Lib/jquery.jConveyorTicker.min';

import * as track from '../track';
import OneVideo from 'Modules/module-oneVideoAutoplay';

"use strict";

export default Backbone.View.extend({

    initialize: function (opts) {
        var self = this;
        self.$content = self.$el;
        self.theBody = $('body');
        self.theHeader = self.theBody.find('header.site-header');        
        self.$homeSlider = self.$content.find('.home-modules');

        self.imageModule();
        self.splitModule();
        self.initVideo();
        self.initLinksModule();
        self.initFeaturedCollection();
        self.initProductScroll();
    },
    
    events: {

    },

    imageModule: function(){
        // var self = this;
        // self.$imageModule = self.$content.find('.image-module,.video-module');

        // if(!self.isMobile()){
        //     _.each(self.$imageModule, function(imageModule){
        //         var thePoster = $(imageModule).find('.large-size').attr('srcset');
        //         if($(imageModule).find('.video-block').length > 0){
        //             $(imageModule).find('.video-block').css({'background-image':'url('+ thePoster +')'})
        //         }
        //     });
        // }

        this.$('section.image-module .section-cta').on('click', function () {
            track.homepageClick('homepage module', track._.getHandleForPathname(this.pathname), 'button');
        });

        // From home-image-module.liquid and home-short-image-module
        if($('section.image-module .background-image').length > 0 && $(window).width() > 767){
            $('.background-image').each(function(){
                var img_url = $(this).attr('bg-image');
                $(this).css({'background-image': img_url }).addClass('changed');
            });
        }

    },

    splitModule: function(){
        this.$('section.split-module .section-cta').on('click', function () {
            track.homepageClick('hero module', track._.getHandleForPathname(this.pathname), 'button');
        });

        this.$('section.split-module .image-anchor').on('click', function () {
            track.homepageClick('hero module', track._.getHandleForPathname(this.pathname), 'image');
        });
    },

    // imageModule2: function(){
    //     var self = this;
    //     self.$imageModule = self.$content.find('.image-module');

    //     self.$imageModule.on('init', function(){
    //         var $currentTextColor = self.$imageModule.find('.slick-current');

    //         self.theBody.removeClass('white-header black-header');
    //         self.$imageModule.find('button').removeClass('white black');

    //         if($currentTextColor.hasClass('white')){
    //             self.theBody.addClass('white-header');
    //             self.$imageModule.find('button').addClass('white');
    //         }else{
    //             self.theBody.addClass('black-header');
    //             self.$imageModule.find('button').addClass('black');
    //         }

    //     });

    //     self.$imageModule.on('afterChange', function(){
    //         var $currentTextColor = self.$imageModule.find('.slick-current');

    //         self.theBody.removeClass('white-header black-header');
    //         self.$imageModule.find('button').removeClass('white black');

    //         if($currentTextColor.hasClass('white')){
    //             self.theBody.addClass('white-header');
    //             self.$imageModule.find('button').addClass('white');
    //         }else{
    //             self.theBody.addClass('black-header');
    //             self.$imageModule.find('button').addClass('black');
    //         }

    //     });

    //     self.$imageModule.slick({
    //         dots: true,
    //         arrows: true,
    //         infinite: true,
    //         speed: 400,
    //         slidesToShow: 1,
    //         fade: true,
    //         centerMode: false,
    //         autoplay: true,
    //         autoplaySpeed: 6000,
    //         variableWidth: false
    //     });
    // },

    initVideo: function(){
        var self = this;
        self.$videoBoxes = self.$content.find('.video-box');
        
        OneVideo.init({
            el: self.$videoBoxes
        });

        if(self.isMobile()){

            // _.each(self.$content.find('.poster-image'), function(posterImgs){
            //     var thePoster = $(posterImgs).attr('data-poster');
            //     if(typeof thePoster !== 'undefined' && thePoster.length){
            //         $(posterImgs).css({ 'background-image': 'url('+ thePoster +')' });
            //     }
            //     thePoster = "";
            // });
        }
    },

    initLinksModule: function(){
        var self = this;
        self.$linksModule = self.$content.find('.links-module');
        self.$linksNav = self.$linksModule.find('.links-nav');
        self.$singleLink = self.$linksNav.find('.single-link');
        self.$linkSlides = self.$linksModule.find('.links-images');
        self.$singleImage = self.$linkSlides.find('.block-container');

        if(self.isMobile() || self.isTablet()){
            self.$linkSlides.slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 400,
                slidesToShow: 1,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 6000,
                variableWidth: false
            });
        }

        self.$singleLink.on('mouseenter',function(e){
            var $currentLink = $(e.currentTarget);
            var $dataLink = $currentLink.data('link');

            $currentLink.siblings().removeClass('active');
            self.$singleImage.removeClass('active');
            
            $('[data-link="'+ $dataLink +'"]').addClass('active');
        });

    },

    initFeaturedCollection: function(){
        var self = this;
        self.$featuredCollection = self.$content.find('.collection-module');
        self.$featuredCollectionSlider = self.$featuredCollection.find('.collection-product-list');

        var slickSettings = {
            arrows: true,
            dots: false,
            infinite: true,
            speed: 400,
            slidesToShow: 1,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 6000,
            slidesToScroll: 2,
            variableWidth: false
        };

        if(!self.isMobile() && !self.isTablet()){
            slickSettings = {
                arrows: false,
                dots: false,
                infinite: true,
                speed: 3000,
                slidesToShow: 6,
                centerMode: true,
                autoplay: true,
                autoplaySpeed: 1,
                slidesToScroll: 1,
                variableWidth: false
            };
        }

        if(!self.isMobile() && !self.isTablet()){
            //Ticker found @ https://www.jqueryscript.net/animation/horizontal-animation-conveyor-ticker.html
            self.$featuredCollectionSlider.jConveyorTicker({
                anim_duration: 300
            });
        }else{
            self.$featuredCollectionSlider.find('ul').slick(slickSettings);
        }

        self.$featuredCollectionSlider.each(function () {
            track._.onCreate(
                this,
                'li:not(.slick-cloned) > a[href*="/products/"]',
                function (link) {
                    // make sure we're not looking at a duplicate
                    if (link.closest('ul').querySelector('a[href="' + link.getAttribute('href') + '"]') !== link)
                        return;

                    var handle = track._.getHandleForPathname(link.pathname);

                    var position = function () {
                        return track._.getElementIndex(link.closest('li'), 'li:not(.slick-cloned)') + 1;
                    };

                    window.ORW.caches.products.get('/products/' + handle + '.js')
                        .done(function (_product) {
                            var product = JSON.parse(JSON.stringify(_product));
                            product.variant = product.variants[0];

                            track.productImpression(product, 'homepage-featured', position());

                            link.addEventListener('click', function () {
                                track.productClick(product, 'template-index-featured', 'homepage-featured', position());
                            });
                        });
                }
            )
        })

    },

    initProductScroll: function(){
        let self = this;
        self.$productScrollModule = self.$content.find('.product-scroll-module');
        self.$productScrollCarousel = self.$productScrollModule.find('.product-scroll-module__carousel');

        self.$productScrollCarousel.on('init', function(event, slick){
            self.$productScrollCarousel.addClass('product-scroll-module__carousel--initialized')
        });

        self.$productScrollCarousel.slick({
            infinite: true,
            arrows: true,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                    }
                }
            ]
        }) 
    },
    
    isMobile: function () {
        var self = this;
        var w = $(window).width();
        if (w <= ORW.responsiveSizes.medium) {
            return true;
        }
        return false;
    },

    isTablet: function () {
        return window.innerWidth > ORW.responsiveSizes.medium &&
            window.innerWidth <= ORW.responsiveSizes.large;
    },

});